import { useState, useEffect } from "react";
import { Button, Card, Col, Row, Container, Alert, Form } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy, faCreditCard } from "@fortawesome/free-solid-svg-icons";
import Swal from 'sweetalert2';
import QRCode from "react-qr-code";
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import Cards from 'react-credit-cards-2';
import MaskedInput from 'react-text-mask'
import Logo from '../../assets/img/logo.svg';
import pix from '../../assets/img/pix.png';
//Estilos para o componente de cartões de crédito
import 'react-credit-cards-2/dist/es/styles-compiled.css';

// Dados simulados do orçamento
const orcamento = {
  id: "orc-1734024283000",
  paciente: "Maria Silva",
  medico: "Médico de teste",
  data: "02/07/2025",
  status: "pendente",
  total: 75,
  itens: [
    { id: "1", nome: "Dipirona 50mg", fabricante: "EMS", quantidade: 2, preco: 10 },
    { id: "2", nome: "Atenolol 25mg", fabricante: "Neo Química", quantidade: 1, preco: 15 },
    { id: "3", nome: "Losartana 50mg", fabricante: "EMS", quantidade: 2, preco: 20 }
  ],
}

export default function BudgetDetails() {
  const [optionSelected, setOptionSelected] = useState(null);
  const [payment, setPayment] = useState(false);

  const [pixCode, setPixCode] = useState('chavepix@achemed.com.br');
  const [timeIsOver, setTimeIsOver] = useState(false);

  const [cardNumber, setCardNumber] = useState('');
  const [expiry, setExpiry] = useState('');
  const [cvc, setCvc] = useState('');
  const [cardName, setCardName] = useState('');
  const [focused, setFocused] = useState('');

  const [authorization, setAuthorization] = useState(false);

  const selectPaymentOption = (option) => {
    setOptionSelected(option)
  }

  const handleCopyPix = () => {
    navigator.clipboard.writeText(pixCode);
    Swal.fire({
      toast: true,
      icon: 'success',
      title: 'Código Pix copiado!',
      position: 'top',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
    });
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secondsLeft = seconds % 60;
    return `${String(minutes).padStart(2, '0')}:${String(secondsLeft).padStart(2, '0')}`;
  };

  const handleInputFocus = ({ target }) => {
    setFocused(target.name);
  };

  return (
    <div className="vh-100" >
      <header className="bg-dark py-3 px-5" style={{ height: '70px' }}>
        <img style={{ marginRight: 0 }} width={140} alt='logo' src={Logo} />
      </header>

      {
        !optionSelected && (
          <main style={{ height: 'calc(100vh - 140px)', flex: '1', overflowY: 'auto', overflowX: 'hidden' }}>
            <Row className="justify-content-center">
              <Col xs={8} sm={6} >
                <div className="d-flex flex-column gap-3">
                  <div className="pt-3">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <h4 className="mb-0 text-center">Detalhes do Orçamento</h4>
                    </div>

                    <div className="d-flex flex-column gap-3">
                      <Row className="g-3">
                        <Col md={4}>
                          <div>Paciente: <span className="fw-bold">{orcamento.paciente}</span></div>
                        </Col>
                        <Col md={4}>
                          <div>Profissional: <span className="fw-bold">{orcamento.medico}</span></div>
                        </Col>
                        <Col md={4}>
                          <div>Data de solicitação: <span className="fw-bold">{orcamento.data}</span></div>
                        </Col>
                      </Row>

                      <hr className="my-2" />

                      <div>
                        <div className="fw-semibold mb-3">Medicamentos</div>
                        <div
                          className="d-flex flex-column gap-3 overflow-auto"
                          style={{ maxHeight: '300px' }}
                        >
                          {orcamento.itens.map((item) => (
                            <div key={item.id} className="d-flex justify-content-between align-items-center p-3 bg-light rounded">
                              <div>
                                <div className="fw-medium">{item.nome}</div>
                              </div>
                              <div className="text-end">
                                <div className="small text-muted">Quantidade: {item.quantidade}</div>
                                <div className="fw-medium">R$ {(item.preco * item.quantidade).toFixed(2)}</div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>

                      <hr className="my-2" />

                      <div className="d-flex justify-content-between align-items-center fs-4 fw-bold">
                        <h5>Total:</h5>
                        <h5 className="text-success">R$ {orcamento.total.toFixed(2)}</h5>
                      </div>
                    </div>
                  </div>

                  {
                    payment ? (
                      <div className="text-center">
                        <h5>Este orçamento já foi pago!</h5>
                      </div>

                    ) : (
                      <div className="text-center">
                        <h5 className="mb-3">Opções de Pagamento</h5>
                        <div className="d-flex justify-content-center gap-3 m-auto">
                          <Button
                            onClick={() => selectPaymentOption('PIX')}
                            variant="outline-success"
                            size="lg"
                            className="d-flex align-items-center justify-content-start"
                            style={{ height: '4rem' }}
                          >
                            <img src={pix} width={50} />
                            <div className="text-start">
                              <div className="fw-semibold">PIX</div>
                            </div>
                          </Button>

                          <Button
                            onClick={() => selectPaymentOption('CARTAO')}
                            variant="outline-primary"
                            size="lg"
                            className="d-flex align-items-center justify-content-start border-2"
                            style={{ height: '4rem' }}
                          >
                            <FontAwesomeIcon icon={faCreditCard} className="me-3" size="lg" />
                            <div className="text-start">
                              <div className="fw-semibold">Cartão</div>
                            </div>
                          </Button>
                        </div>
                      </div>
                    )
                  }
                </div>
              </Col>
            </Row>
          </main>
        )
      }

      {
        optionSelected === 'PIX' && (
          <Container style={{ height: 'calc(100vh - 140px)', overflowY: 'auto' }} className="d-flex justify-content-center align-items-start mt-4">
            <Card className="w-100" style={{ maxWidth: '500px' }}>
              <Card.Body>
                <Card.Title className="text-center mb-4">Pagamento PIX</Card.Title>

                <div className="text-center mb-3">
                  Leia o QR Code ou copie a chave PIX abaixo
                </div>

                <div
                  className="border text-center p-2 my-4 rounded cursor-pointer text-truncate"
                  style={{ cursor: 'pointer' }}
                >
                  <span className="font-monospace">{pixCode}</span>
                  <FontAwesomeIcon icon={faCopy} className="ms-4" onClick={handleCopyPix} style={{ cursor: 'pointer' }} />
                </div>

                {pixCode && (
                  <div className="d-flex justify-content-center mb-3">
                    <QRCode
                      size={150}
                      value={pixCode}
                      viewBox={`0 0 150 150`}
                    />
                  </div>
                )}

                <div className="d-flex justify-content-center mb-4">
                  <CountdownCircleTimer
                    isPlaying
                    size={100}
                    duration={20}
                    colors={['#004777', '#F7B801', '#A30000']}
                    colorsTime={[20, 10, 0]}
                    onComplete={() => setTimeIsOver(true)}
                    strokeWidth={5}
                  >
                    {({ remainingTime }) => formatTime(remainingTime)}
                  </CountdownCircleTimer>
                </div>

                <Card className="bg-light p-2 mb-2">
                  <p>Paciente: {orcamento.paciente} </p>
                  <p>Profissional: {orcamento.medico} </p>
                  <p>Data da solicitação: {orcamento.data} </p>
                  <p>Valor a pagar: R$ {orcamento.total.toFixed(2)} </p>
                </Card>

              </Card.Body>
            </Card>
          </Container>
        )
      }

      {
        optionSelected === 'CARTAO' && (
          <Container style={{ height: 'calc(100vh - 140px)' }} className="d-flex justify-content-center align-items-start">
            <Card className="w-100 mt-5" style={{ maxWidth: '600px' }}>
              <Card.Body>
                <Card.Title className="text-center mb-4">Pagamento por Cartão</Card.Title>

                <Cards
                  number={cardNumber}
                  expiry={expiry}
                  cvc={cvc}
                  name={cardName}
                  focused={focused}
                  placeholders={{
                    name: "SEU NOME AQUI"
                  }}
                  locale={{ valid: "Válido até" }}
                />

                <Form>
                  <Form.Group className="my-3">
                    <Form.Label>Número do cartão</Form.Label>
                    <MaskedInput
                      mask={[/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/]}
                      className="form-control"
                      name="number"
                      placeholder="1234 5678 1234 5678"
                      value={cardNumber}
                      onChange={(e) => setCardNumber(e.target.value)}
                      onFocus={handleInputFocus}
                      guide={false}
                    />
                  </Form.Group>

                  <Row className="mb-3">
                    <Form.Group className="col-6">
                      <Form.Label>Data de vencimento</Form.Label>
                      <MaskedInput
                        mask={[/\d/, /\d/, '/', /\d/, /\d/]}
                        className="form-control"
                        name="expiry"
                        placeholder="MM / AA"
                        value={expiry}
                        onChange={(e) => setExpiry(e.target.value)}
                        onFocus={handleInputFocus}
                        guide={false}
                      />
                    </Form.Group>

                    <Form.Group className="col-6">
                      <Form.Label>CVC / CVV</Form.Label>
                      <Form.Control
                        type="number"
                        name="cvc"
                        placeholder="000"
                        maxLength={4}
                        value={cvc}
                        onChange={(e) => setCvc(e.target.value)}
                        onFocus={handleInputFocus}
                      />
                    </Form.Group>
                  </Row>

                  <Form.Group className="mb-3">
                    <Form.Label>Nome no cartão</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder="NOME COMO APARECE NO CARTÃO"
                      value={cardName}
                      onChange={(e) => setCardName(e.target.value.toUpperCase())}
                      onFocus={handleInputFocus}
                    />
                  </Form.Group>

                  <Form.Check
                    className="mb-3"
                    type="checkbox"
                    label="Autorizo a salvar os dados desse cartão"
                    checked={authorization}
                    onChange={(e) => setAuthorization(e.target.checked)}
                  />

                  <div className="d-flex w-100 justify-content-center">
                    <Button type="submit">Confirmar pagamento</Button>
                  </div>

                </Form>
              </Card.Body>
            </Card>
          </Container>
        )
      }

      <footer className="bg-dark py-3 text-white text-center mt-2" style={{ height: '70px' }}>
        Achemed © Todos os direitos reservados. {new Date().getFullYear()}
      </footer>
    </div>
  )
}